//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQBadge from "../AQBadge/AQBadge.vue";

export default {
    name: "AQDropdownbadge",
    components: {
        AQBadge
    },
    props: {
        badgeList: {
            type: Array,
            default() {
                return [];
            }
        },
        selectedBadge: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            badgeType: null,
            stylePopover: {
                border: "1px solid #5B6D5B",
                "box-sizing": "border-box",
                "box-shadow": "0px 4px 8px rgba(36, 45, 56, 0.06)",
                "border-radius": "0px 0px 8px 8px",
                padding: "6px 0px 6px 0px"
            },
            isOpened: false
        };
    },
    created() {
        if (this.selectedBadge) {
            this.badgeType = this.selectedBadge;
        } else {
            [this.badgeType] = this.badgeList;
        }
    },
    methods: {
        changeBadge(item, clicked) {
            const badgeClass = {
                mod: "mod",
                date: "date-time",
                time: "date-time",
                datetime: "date-time",
                logical: "logical",
                txt: "txt"
            };
            this.badgeType = item;
            this.$emit("input", item);
            if (clicked) {
                this.$emit("selected", item);
            }
            return badgeClass[item.value];
        },
        beforeShow(event) {
            this.$emit("beforeShow", event);
        },
        show(event) {
            this.isOpened = true;
            this.$emit("show", event);
        },
        beforeHide(event) {
            this.$emit("beforeHide", event);
        },
        hide(event) {
            this.isOpened = false;
            this.$emit("hide", event);
        }

    }
};
